const Page403 = () => (
  <div
    style={{
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translateX(-50%) translateY(-50%)',
      backgroundColor: '#d0ff6f',
      borderRadius: '10px',
      color: '#7d0a34',
      padding: '10px',
      minWidth: '250px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column'
    }}
  >
    <span>Access denied</span>
  </div>
);

export default Page403;
